import React from 'react';
import styled from 'styled-components';

import { NoteType } from '../features/recruitments/Recruitments.types';

import { Note } from './Note';
import { StyledColumn } from './StyledColumn';

const List = styled(StyledColumn)`
  padding: 20px 10px;
  gap: 0.7rem;

  ::-webkit-scrollbar {
    width: 6px;
  }

  ::-webkit-scrollbar-track {
    background: #f5f5f5;
  }

  ::-webkit-scrollbar-thumb {
    background-color: #bdbdbd;
  }
`;

export type CandidateNotesProps = {
  notes: NoteType[];
  onEdit: (noteId: number) => void;
  onDelete: (noteId: number) => void;
};

export const CandidateNotesList: React.FC<CandidateNotesProps> = ({ notes, onEdit, onDelete }) => {
  return (
    <List>
      {notes.map((note, index) => {
        return <Note note={note} onEdit={onEdit} onDelete={onDelete} key={note.id ?? index} />;
      })}
    </List>
  );
};
